import Text, { TextProps } from './Text';
export default Text;
export type { TextProps };
